import React from 'react';

const ChiyaSeed = () => {
    return (
        <div>
            <p style={{ textAlign: 'center', marginTop: '2%', fontSize: '22px', textTransform: 'capitalize', fontWeight: 'bold' }}>
                hello this is চিয়া সিড page that you r browsing
            </p>

        </div>
    );
};

export default ChiyaSeed;